import request from '@/utils/request'
import sapRequest from '@/utils/sap-request'
import { BASE_API } from '@/api/baseUrl'

/**
 * 客户主数据api
 * 客户查询
 * @param {*} params
 */
export function findAllClientInfo(data) {
  return request({
    url: BASE_API() + '/mdm/client/findAllClientInfoMdm',
    method: 'post',
    data
  })
}

/**
 * 客户主数据api
 * 客户数据详情
 * @param {*} params
 */
export function findClientInfoById(params) {
  return request({
    url: BASE_API() + '/mdm/client/findClientInfoById',
    method: 'get',
    params
  })
}

/**
 * 客户主数据api
 * 查询客户营销单元
 * @param {*} params
 */
export function findClientOrg(params) {
  return request({
    url: BASE_API() + '/mdm/client/findClientOrg',
    method: 'get',
    params
  })
}

/**
 * 客户主数据api
 * 客户数据添加可售清单
 * @param {*} params
 */
export function addClientProduct(data) {
  return request({
    url: BASE_API() + '/mdm/client/addClientProduct',
    method: 'post',
    data
  })
}

/**
 * 客户主数据api
 * 客户数据删除可售清单
 * @param {*} params
 */
export function deleteClientProduct(params) {
  return request({
    url: BASE_API() + '/mdm/client/deleteClientProduct',
    method: 'delete',
    params
  })
}

/**
 * 客户主数据api
 * 客户数据删除可售清单
 * @param {*} params
 */
export function deleteClientAddress(params) {
  return request({
    url: BASE_API() + '/mdm/client/deleteClientAddress',
    method: 'delete',
    params
  })
}

/**
 * 客户主数据api
 * 客户可售清单
 * @param {*} params
 */
export function findProductsByClientId(params) {
  return request({
    url: BASE_API() + '/mdm/client/findProductsByClientId',
    method: 'get',
    params
  })
}

/**
 * 客户主数据api
 * 客户变更历史
 * @param {*} params
 */
export function findChangeByCustomerCode(params) {
  return request({
    url: BASE_API() + '/mdm/client/findChangeByCustomerCode',
    method: 'get',
    params
  })
}

/**
 * 客户主数据api
 * 客户渠道信息
 * @param {*} params
 */
export function findChannelByCustomerCode(params) {
  return request({
    url: BASE_API() + '/mdm/client/findChannelByCustomerCode',
    method: 'get',
    params
  })
}

/**
 * 客户主数据api
 * 添加客户关系
 * @param {*} params
 */
export function addClientRelaship(data) {
  return request({
    url: BASE_API() + '/mdm/client/addClientRelaship',
    method: 'post',
    data
  })
}

/**
 * 客户主数据api
 * 删除客户关系
 * @param {*} params
 */
export function deleteClientRelaship(params) {
  return request({
    url: BASE_API() + '/mdm/client/deleteClientRelaship',
    method: 'delete',
    params
  })
}

/**
 * 客户主数据api
 * 客户地址信息
 * @param {*} params
 */
export function findAddressByClientId(data) {
  return request({
    url: BASE_API() + '/mdm/client/findAddressByClientId',
    method: 'post',
    data
  })
}

/**
 * 客户主数据api
 * 添加客户地址信息
 * @param {*} params
 */
export function addClientAddress(data) {
  return request({
    url: BASE_API() + '/mdm/client/addClientAddress',
    method: 'post',
    data
  })
}

/**
 * 客户主数据api
 * 添加客户变更记录
 * @param {*} params
 */
export function addClientChange(data) {
  return request({
    url: BASE_API() + '/mdm/client/addClientChange',
    method: 'post',
    data
  })
}

/**
 * 客户主数据api
 * 客户关系
 * @param {*} params
 */
export function findRelationByClientId(params) {
  return request({
    url: BASE_API() + '/mdm/client/findRelationByClientId',
    method: 'get',
    params
  })
}

/**
 * 客户主数据api
 * 客户银行信息
 * @param {*} params
 */
export function queryBankList(params) {
  return request({
    url: BASE_API() + '/mdm/client/queryBankList',
    method: 'get',
    params
  })
}

/**
 * 客户主数据api
 * 客户关系报表
 * @param {*} params
 */
export function getRelationReport(data) {
  return request({
    url: BASE_API() + '/mdm/client/getRelationReport',
    method: 'post',
    data
  })
}

/**
 * 客户主数据api
 * 修改客户主数据
 * @param {*} params
 */
export function updateClientInfo(data) {
  return request({
    url: BASE_API() + '/mdm/client/updateClientInfo',
    method: 'post',
    data
  })
}

/**
 * 客户主数据api
 * 客户地址信息
 * @param {*} params
 */
export function getAddressReport(data) {
  return request({
    url: BASE_API() + '/mdm/client/getAddressReport',
    method: 'post',
    data
  })
}
/**
 * 客户主数据api
 * 查询客户营销单元
 * @param {*} params
 */
export function getClientSaleCenter(params) {
  return request({
    url: BASE_API() + '/mdm/client/findClientOrg',
    method: 'get',
    params
  })
}
/**
 * 客户主数据api
 * 查询组织机构
 * @param {*} params
 */
export function findWlyOrg(params) {
  return request({
    url: BASE_API() + '/mdm/client/findWlyOrg',
    method: 'get',
    params
  })
}
/**
 * 客户主数据api
 * 保存客户营销单元
 * @param {*} params
 */
export function addClientOrg(data) {
  return request({
    url: BASE_API() + '/mdm/client/addClientOrg',
    method: 'post',
    data
  })
}
/**
 * 客户主数据api
 * 删除营销单元
 * @param {*} params
 */
export function deleteClientOrg(params) {
  return request({
    url: BASE_API() + '/mdm/client/deleteClientOrg',
    method: 'delete',
    params
  })
}
/**
 * 客户主数据api
 * 新增渠道
 * @param {*} params
 */
export function addClientChannel(data) {
  return request({
    url: BASE_API() + '/mdm/client/addClientChannel',
    method: 'post',
    data
  })
}
/**
 * 客户主数据api
 * 删除渠道
 * @param {*} params
 */
export function deleteClientChannel(params) {
  return request({
    url: BASE_API() + '/mdm/client/deleteClientChannel',
    method: 'delete',
    params
  })
}
/**
 * 客户主数据api
 * 生成申请单号
 * @param {*} params
 */
 export function getApplyForNum(params) {
  return request({
    url: BASE_API() + '/mdm/client/saveAddressChange',
    method: 'post',
    params
  })
}
/**
 * 客户主数据api
 * 查询修改的数据
 * @param {*} params
 */
 export function getUpdateData(params) {
  return request({
    url: BASE_API() + '/mdm/client/findById',
    method: 'post',
    params
  })
}
/**
 * 客户主数据api
 * 删除地址数据
 * @param {*} data
 */
 export function deleteAddress(data) {
  return request({
    url: BASE_API() + '/mdm/client/deleteAddress',
    method: 'post',
    data
  })
}
/**
 * 客户主数据api
 * 查询地址数据
 * @param {*} data
 */
 export function getDataFromSap(data) {
  return request({
    url: BASE_API() + '/mdm/client/getDataFromSap',
    method: 'post',
    data
  })
}
/**
 * 客户主数据api
 * 保存申请详情
 * @param {*} params
 */
 export function saveAddressDtl(params) {
  return request({
    url: BASE_API() + '/mdm/client/addAddressDtl',
    method: 'post',
    params
  })
}

/**
 * 商机主数据查询api
 *
 * @param {*} params
 */
export function apiMerchantOrgQuery(data) {
  return sapRequest({
    url: 'sap/bc/ztpm/to_new_crm/transdata/busoppid_ovs',
    method: 'POST',
    data
  })
}

/**
 * 团购单位信息查询
 *
 * @param {*} params
 */
export function apiFindGroupCompany(data) {
  return sapRequest({
    url: 'sap/bc/ztpm/to_new_crm/transdata/grputid_ovs',
    method: 'post',
    data
  })
}

/**
 * 新增地址和新增客户前初始化接口
 *
 * @param {*} params
 */
export function apiInitClientAdd(data) {
  return sapRequest({
    url: 'sap/bc/ztpm/to_new_crm/transdata/bp_addr_check',
    method: 'post',
    data
  })
}

/**
 * 新增客户地址和客户
 *
 * @param {*} params
 */
export function apiClientAdd(data) {
  return sapRequest({
    url: 'sap/bc/ztpm/to_new_crm/transdata/bp_addr_import',
    method: 'post',
    data
  })
}

/**
 * 团购客户新增运达方（实际只增加了地址信息）customerCode不填自动生成，groupCode、groupName从所选团购单位带过来
 *
 * @param {*} params
 */
export function apiAddGroupArrivalCoustomer(params) {
  return request({
    url: BASE_API() + '/mdm/client/addGroupArrivalCoustomer',
    method: 'post',
    data: params
  })
}
/**
 * 保存发货审批人
 *
 * @param {*} params
 */
export function apiSaveOrUpdateApprove(data) {
  return request({
    url: BASE_API() + '/mdm/client/saveOrUpdateApprove',
    method: 'post',
    data
  })
}
/**
 * 查询发货审批人
 *
 * @param {*} params
 */
export function apiFindCustomerApprove(params) {
  return request({
    url: BASE_API() + '/mdm/client/findCustomerApprove',
    method: 'get',
    params
  })
}
/**
 * 查询营销战区审批人
 *
 * @param {*} params
 */
export function apiFindSaleManager(data) {
  return request({
    url: BASE_API() + '/mdm/client/findSaleManager',
    method: 'post',
    data
  })
}
/**
 * 保存营销战区审批人
 *
 * @param {*} params
 */
export function apiSaveSaleManagerByCenter(data) {
  return request({
    url: BASE_API() + '/mdm/client/saveSaleManagerByCenter',
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/api/client.js